export default __webpack_public_path__ + "static/media/angleDownGreen.a6e0f572.svg";